import {
  AfterContentChecked,
  AfterContentInit,
  Component, ContentChild,
  ElementRef,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatTabGroup, MatTabHeaderPosition } from '@angular/material/tabs';

@Component({
    selector: 'mbnm-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarouselComponent implements OnInit, AfterContentInit, AfterContentChecked {

  constructor(public elementRef: ElementRef) {
  }

  public oneTabOnly = false;
  @ContentChild(MatTabGroup) tabGroup: MatTabGroup;
  @Input() navPosition: MatTabHeaderPosition = 'above';

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.tabGroup.headerPosition = this.navPosition;
    this.tabGroup.dynamicHeight = true;
  }

  ngAfterContentChecked() {
    this.oneTabOnly = this.tabGroup._tabs.length === 1;
  }
}

